<script>
    import LyCenterBox from './components/LyCenterBox.svelte';
    import DoLogin from './login/DoLogin.svelte';
    import DoRegisterUser from './login/DoRegisterUser.svelte';
    import DoResetPassword from './login/DoResetPassword.svelte';

    /** @type {'' | 'register' | 'resetPassword'} */
    let loginMode = $state('');
    let email = $state('');
</script>

<div
    class="flex h-dvh w-dvw
           items-center justify-center overflow-hidden
           bg-gray-200">
    <LyCenterBox>
        {#if loginMode === 'register'}
            <DoRegisterUser
                openLogin={() => (loginMode = '')}
                openResetPassword={(mail) => {
                    email = mail;
                    loginMode = 'resetPassword';
                }} />
        {:else if loginMode === 'resetPassword'}
            <DoResetPassword
                {email}
                openLogin={() => {
                    email = '';
                    loginMode = '';
                }} />
        {:else}
            <DoLogin
                openRegister={() => {
                    email = '';
                    loginMode = 'register';
                }}
                openNewPassword={() => {
                    email = '';
                    loginMode = 'resetPassword';
                }} />
        {/if}
    </LyCenterBox>
</div>
